import { createSelector } from 'reselect'
import getBedbankItems from './getBedbankItems'

export interface BedbankReduceState {
  isReduce: boolean
  hasSelectedShorterDuration: boolean
  hasSession: boolean
  /** Reduce has started but the shorter stay has not been session-priced yet. */
  pendingPrice: boolean
}

/** Shared reduce-nights checkout state derived from the bedbank cart item. */
const getBedbankReduceState = createSelector(
  getBedbankItems,
  (state: App.State) => state.checkout.cart.existingOrder?.bedbankItems ?? [],
  (bedbankItems, orderBedbankItems): BedbankReduceState => {
    const reduceItems = bedbankItems.filter(item => item.reduceDatesOnly)
    const isReduce = reduceItems.length > 0
    const hasSession = isReduce && reduceItems.every(item => !!item.sessionId)
    const hasSelectedShorterDuration = isReduce && reduceItems.every(item => {
      const orderItem = orderBedbankItems.find(orderItem => orderItem.id === item.orderItemId)
      return !!orderItem?.duration && item.duration < orderItem.duration
    })

    return {
      isReduce,
      hasSelectedShorterDuration,
      hasSession,
      pendingPrice: isReduce && !hasSession,
    }
  },
)

export default getBedbankReduceState
